
var textNL={
    voegAfbeeldingToe:"Voeg een afbeelding toe door een bestand te kiezen of een afbeelding van het klembord toe te voegen.",
    gebruikKnoppen:"Gebruik de knoppen om de afbeelding goed te zetten. Of sleep de afbeelding om hem te verplaatsen.",
    addTitel:"Voeg een titel toe.",
    dowload:"Als je tevreden bent met de Afbeelding en klik op 'Download Thumbnail'.",
    kiesTemplate:"Kies je sjabloom.",
    kiesGetal:"Kies een getal.",
    choooseDate:"Kies een datum.",
    kiesProgramma:"Kies het tv programma logo"
}
export default textNL